import {Box, Button, CardMedia, CssBaseline, Divider, Grid, Link, TextField, Typography} from "@mui/material";
import {OptionsObject, useSnackbar} from "notistack";
import background from "../../assets/login_background.png";
import logo from "../../assets/logo.png";
import {useEffect, useRef, useState} from "react";
import {RegisterAPI} from "../../api/authentication/AuthenticationAPI";
import {AlertErrorProp, AlertSuccessProp,} from "../../components/SnackbarNoti";
import Paper from "@mui/material/Paper";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import {initializeGoogleClient} from "../../util/GoogleLoginHandler";
import {useTranslation} from "react-i18next";
import ReCAPTCHA from "react-google-recaptcha";
import {GOOGLE_CAPTCHA_ID} from "../../api/DefaultConfig";

const theme = createTheme();

function Copyright(props: any) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://trendz.vn/">
        trendz.vn
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

function RegisterPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const {t} = useTranslation(["common", "account"]);
  const {enqueueSnackbar} = useSnackbar();
  const g_sso = useRef(null);
  const [enableSubmit, setEnableSubmit] = useState(
    window.location.toString().startsWith("https://trendz.vn") ? false : true
  );

  function onCaptchaDone() {
    setEnableSubmit(true);
  }

  const requestOptions = {
    method: "POST",
    headers: {"Content-Type": "application/json"},
    body: JSON.stringify({email: email, password: password, name: name}),
  };

  useEffect(() => {
    initializeGoogleClient()
    //.catch((err) => {console.log("GOOGLE LOGIN MAY BE UNAVAILABLE")});
  });

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (password == passwordAgain && password.length >= 8) {
      fetch(RegisterAPI, requestOptions)
        .then((response) => {
          if (!response.ok) {
            enqueueSnackbar(
              "Invalid credentials",
              AlertErrorProp as OptionsObject
            );
          } else
            enqueueSnackbar(
              "Register successfully, please check your email",
              AlertSuccessProp as OptionsObject
            );
        })
        .catch((err) => {
          enqueueSnackbar(
            "Invalid credentials",
            AlertErrorProp as OptionsObject
          );
        });
    } else if (password.length < 8) {
      enqueueSnackbar(
        "Password too weak. Try again",
        AlertErrorProp as OptionsObject
      );
    } else {
      enqueueSnackbar(
        "Password and Confirmed Password mismatched. Try again",
        AlertErrorProp as OptionsObject
      );
    }
  };
  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{height: "100vh"}} className="fadein">
        <CssBaseline/>
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: `url(${background})`,
            backgroundRepeat: "no-repeat",
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <Grid item xs={12} sm={8} md={5}
              component={Paper}
              elevation={6}
              sx={{display: "flex", alignItems: "center"}}
        >
          <Box
            className="fadein"
            sx={{
              margin: "24px auto",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Link href="/">
              <CardMedia
                image={logo}
                sx={{
                  mx: 2,
                  width: "250px",
                  height: "60px",
                  marginBottom: "32px",
                }}
              />
            </Link>
            <Box
              component="form"
              noValidate
              onSubmit={handleSubmit}
              sx={{mt: 1, mx: 8}}
            >
              <TextField
                size='small'
                margin="normal"
                fullWidth
                type={"text"}
                placeholder={t("account:enter_your_name").toString() + " *"}
                value={name}
                autoFocus
                onChange={(e) => {
                  setName((e.target as HTMLInputElement).value);
                }}
              />
              <TextField
                size='small'
                margin="dense"
                fullWidth
                required
                placeholder={t("account:enter_email").toString() + " *"}
                value={email}
                onChange={(e) => {
                  setEmail((e.target as HTMLInputElement).value);
                }}
              />
              <TextField
                size='small'
                margin="dense"
                sx={{width: "48%", marginRight: "4%"}}
                required
                type="password"
                placeholder={t("account:enter_password").toString() + " *"}
                value={password}
                onChange={(e) => {
                  setPassword((e.target as HTMLInputElement).value);
                }}
              />
              <TextField
                size='small'
                margin="dense"
                sx={{width: "48%"}}
                required
                type="password"
                placeholder={
                  t("account:enter_password_to_confirm").toString() + " *"
                }
                style={{marginBottom: "16px"}}
                value={passwordAgain}
                onChange={(e) => {
                  setPasswordAgain((e.target as HTMLInputElement).value);
                }}
              />
              <ReCAPTCHA
                className="captcha-box"
                sitekey={GOOGLE_CAPTCHA_ID}
                onChange={onCaptchaDone}
                style={{
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                }}
              />
              <Button
                disabled={!enableSubmit}
                type="submit"
                fullWidth
                onClick={handleSubmit}
                variant="contained"
                sx={{mt: 1.2, backgroundColor: '#277bfa'}}
              >
                {t("account:register")}
              </Button>
              <Divider sx={{margin: "8px auto", width: "100%"}}>or</Divider>
              <Button
                disabled={!enableSubmit}
                id="google-signin-button"
                fullWidth
              />
              <Box marginTop={1.4} sx={{display: "flex", justifyContent: "center"}}>
                <Link href="/login" variant="body2">
                  {t("account:ask_for_sign_in")}
                </Link>
              </Box>
              {/*<Copyright sx={{ mt: 5 }} />*/}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}

export default RegisterPage;
